/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Alert, AlertTitle, Button, Paper } from "../../components/UI/basicos";
import useLogin from "../../hooks/useLogin";
import {
  ConfiguracionGetUUID,
  ConfiguracionUpdate,
} from "../../service/configuracion";
import "./style/app.css";

const TIPOS_CAMPO = [
  { value: "text", label: "Texto" },
  { value: "number", label: "Número" },
  { value: "email", label: "Correo electrónico" },
  { value: "password", label: "Contraseña" },
  { value: "date", label: "Fecha" },
  { value: "time", label: "Hora" },
  { value: "datetime-local", label: "Fecha y hora" },
  { value: "color", label: "Color" },
  { value: "tel", label: "Teléfono" },
  { value: "file", label: "Archivo" },
  { value: "range", label: "Rango" },
  { value: "search", label: "Búsqueda" },
  { value: "url", label: "URL" },
  { value: "select", label: "Opciones" },
];

const parsePreguntas = (preguntas) => {
  if (!preguntas) return [];
  if (Array.isArray(preguntas)) return preguntas;

  try {
    const parsed = JSON.parse(preguntas);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export default function UpdateFormulario() {
  const { uuid } = useParams();
  const { token } = useLogin();

  const [configuracion, setConfiguracion] = useState(null);
  const [preguntas, setPreguntas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelado = false;

    const cargar = async () => {
      setCargando(true);
      try {
        const response = await ConfiguracionGetUUID(uuid, token);
        if (cancelado) return;

        if (response?.data) {
          setConfiguracion(response.data);
          setPreguntas(parsePreguntas(response.data.preguntas));
        } else {
          setError(response?.message || "No se encontró el formulario");
        }
      } catch (e) {
        if (!cancelado) setError("No se pudo conectar con el servidor");
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    cargar();
    return () => {
      cancelado = true;
    };
  }, [uuid, token]);

  const actualizarPregunta = (index, cambios) => {
    setPreguntas((actuales) =>
      actuales.map((pregunta, i) =>
        i === index ? { ...pregunta, ...cambios } : pregunta
      )
    );
  };

  const eliminarPregunta = (index) => {
    setPreguntas((actuales) => actuales.filter((_, i) => i !== index));
  };

  const agregarPregunta = () => {
    setPreguntas((actuales) => [
      ...actuales,
      { label: "", type: "text", value: "" },
    ]);
  };

  const guardar = () => {
    const sinTitulo = preguntas.some((pregunta) => !pregunta.label?.trim());
    if (sinTitulo) {
      Swal.fire({
        icon: "warning",
        title: "Faltan títulos",
        text: "Todas las preguntas necesitan un título.",
      });
      return;
    }

    // Se reenvía el objeto completo que devolvió el backend (id, uuid, user_id,
    // cliente_id...) con las preguntas actualizadas, para no perder campos.
    const data = {
      ...configuracion,
      preguntas: JSON.stringify(preguntas),
    };

    setGuardando(true);
    ConfiguracionUpdate(data, token)
      .then((response) => {
        if (response?.success) {
          Swal.fire({
            icon: "success",
            title: "Exito",
            text: "Se actualizó el formulario correctamente",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response?.message || "No se pudo actualizar el formulario",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo conectar con el servidor",
        });
      })
      .finally(() => setGuardando(false));
  };

  if (cargando) {
    return (
      <Alert severity="info" style={{ width: "100%" }}>
        Cargando formulario...
      </Alert>
    );
  }

  if (error) {
    return (
      <Alert severity="error" style={{ width: "100%" }}>
        <AlertTitle>
          <strong>Error</strong>
        </AlertTitle>
        {error}
      </Alert>
    );
  }

  return (
    <div className="App formulario-builder">
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-5">
          <Paper elevation={3} sx={{ padding: "15px" }}>
            <h2 className="text-center mt-3">
              Editar formulario de proveedores
            </h2>
          </Paper>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-12 d-flex justify-content-between align-items-center">
          <Link
            className="btn btn-link"
            target="_blank"
            to={`/configuracion/view-formulario/${uuid}`}
          >
            Ver formulario publicado
          </Link>
          <Button variant="contained" onClick={agregarPregunta}>
            Añadir nueva pregunta
          </Button>
        </div>
      </div>

      {preguntas.length === 0 ? (
        <div className="row mt-3">
          <div className="col-md-12">
            <Alert severity="info" style={{ width: "100%" }}>
              <AlertTitle>
                <strong>Info</strong>
              </AlertTitle>
              Este formulario no tiene preguntas. Añade al menos una.
            </Alert>
          </div>
        </div>
      ) : (
        <div className="row mt-3">
          {preguntas.map((pregunta, index) => (
            <div className="col-md-4 mb-3" key={index}>
              <Paper elevation={2} sx={{ padding: "12px" }}>
                <label className="text-dark" htmlFor={`label-${index}`}>
                  Título de la pregunta
                </label>
                <input
                  id={`label-${index}`}
                  className="form-control"
                  type="text"
                  value={pregunta.label || ""}
                  onChange={(e) =>
                    actualizarPregunta(index, { label: e.target.value })
                  }
                />

                <label className="text-dark mt-2" htmlFor={`type-${index}`}>
                  Tipo de campo
                </label>
                <select
                  id={`type-${index}`}
                  className="form-control"
                  value={pregunta.type || "text"}
                  onChange={(e) =>
                    actualizarPregunta(index, {
                      type: e.target.value,
                      opciones:
                        e.target.value === "select"
                          ? pregunta.opciones || []
                          : undefined,
                    })
                  }
                >
                  {TIPOS_CAMPO.map((tipo) => (
                    <option key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </option>
                  ))}
                </select>

                {pregunta.type === "select" && (
                  <>
                    <label className="text-dark mt-2" htmlFor={`opc-${index}`}>
                      Opciones (separadas por coma)
                    </label>
                    <input
                      id={`opc-${index}`}
                      className="form-control"
                      type="text"
                      value={(pregunta.opciones || []).join(", ")}
                      onChange={(e) =>
                        actualizarPregunta(index, {
                          opciones: e.target.value
                            .split(",")
                            .map((opcion) => opcion.trim())
                            .filter(Boolean),
                        })
                      }
                    />
                  </>
                )}

                <div className="text-end mt-3">
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    disabled={pregunta.disabled ? true : false}
                    onClick={() => eliminarPregunta(index)}
                  >
                    Eliminar
                  </Button>
                </div>
              </Paper>
            </div>
          ))}
        </div>
      )}

      <div className="row">
        <div className="col-md-12 d-flex justify-content-end">
          <Button
            variant="contained"
            color="success"
            onClick={guardar}
            disabled={guardando}
          >
            {guardando ? "Guardando..." : "Guardar cambios"}
          </Button>
        </div>
      </div>
    </div>
  );
}
